

document.addEventListener('DOMContentLoaded', () => {
  const target_audience = document.getElementById('target_audience');
  const course_type = document.getElementById('course_type');
  const link = document.getElementById('course-search-link');
  link.addEventListener('click', (e) =>{
    e.preventDefault()
    window.location.href = link.href + '?' + 'malgruppe=' + target_audience.value + '&' + 'kategorier=' + course_type.value;
})

})